import { areahubColors } from "./areahub";
import { brandColors } from "./brands";
import { chakraColors } from "./chakra";
import { enterpriseColors } from "./enterprise";
import { tailwindColors } from "./tailwind";

const colors = {
  ...brandColors,
  ...tailwindColors,
  ...chakraColors,
  ...areahubColors,
  text: tailwindColors.blueGray[800],
  brand: areahubColors.blue,
  premium: areahubColors.darkGreen,
  enterpriseColors: enterpriseColors,
};

export default colors;
